import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation } from 'react-router';
import { Flex, HeaderItalic, ScrollArea, TabNav } from '@/components/common';
import { PageTopBar } from '@/components/layout';

export function InboxPage() {
  const { t } = useTranslation('chat');
  const { pathname } = useLocation();
  const likesActive = pathname === '/inbox/likes';

  return (
    <ScrollArea scrollbars="vertical">
      <PageTopBar centerSlot={<HeaderItalic>{t('inbox.title')}</HeaderItalic>} />

      <TabNav.Root className="px-3">
        <TabNav.Link asChild active={!likesActive}>
          <Link to="/inbox" data-testid="inbox-tab-messages">
            {t('inbox.tabs.messages')}
          </Link>
        </TabNav.Link>
        <TabNav.Link asChild active={likesActive}>
          <Link to="/inbox/likes" data-testid="inbox-tab-likes">
            {t('inbox.tabs.likes')}
          </Link>
        </TabNav.Link>
      </TabNav.Root>

      <Flex direction="column" gap="4" pb="2" px="3">
        <Outlet />
      </Flex>
    </ScrollArea>
  );
}
